﻿import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'dialog-confirmation-component',
    styleUrls: ['confirmation.dialogcomponent.css'],
    templateUrl: 'confirmation.dialogcomponent.html',
})
export class ConfirmationDialogComponent implements OnInit {
    title: string;
    message: string;
    iconcolor: string;
    iconname: string;
    oktext: string;
    canceltext: string;
    showIcon: boolean;

    constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) data: BaseConfirmationDialogOptions) {
        this.title = data.TitleText || 'Confirmation Requested...';
        this.message = data.MessageText || '';
        this.iconcolor = data.IconColor || 'primary';
        this.iconname = data.IconName || 'help';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.showIcon = data.ShowIcon != null ? data.ShowIcon : true;
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    ngOnInit() {}

    OKHandler() {
        this.dialogRef.close(true);
    }
}

// #region Custom Classes

export class BaseConfirmationDialogOptions {
    /** Text that appears in the title bar of the dialog. */
    TitleText?: string;
    /** Text that appears in the main body of the dialog. HTML formatting is acceptable. */
    MessageText?: string;
    /** Text which will appear as the OK button element text. */
    OKText?: string;
    /** Text which will appear as the cancel button element text. */
    CancelText?: string;
    /** Color for an optional dialog box icon. Choose from 'primary', 'accent', or 'warn' */
    IconColor?: string;
    /** (Optional) Name for the Material Icon library icon to appear in the corner of the dialog box. */
    IconName?: string;
    /** (Optional) Determines if a Material Icon should appear in the corner of the dialog box. */
    ShowIcon?: boolean;
    /** Override the height of the dialog on the screen. All CSS units are acceptable. */
    height?: string;
    /** Override the width of the dialog on the screen. All CSS units are acceptable. */
    width?: string;
}

// #endregion
